/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

// import { Circle } from '@mui/icons-material';
// import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
// import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Container, Typography, Paper, Stack } from '@mui/material';
// import Button from '@mui/material/Button';
// import MobileStepper from '@mui/material/MobileStepper';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// import SwipeableViews from 'react-swipeable-views';
// import { autoPlay } from 'react-swipeable-views-utils';

import { loadSalesOrgData, getShipToPartyData } from '../../actions/index';
// import i18n from '../../helpers/i18nMain';
import { homeConfigData } from './config';
import { styles } from './styles';

// const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// const MyCollection = [
//   {
//     label: 'Slide 1',
//     imgPath: 'image-2.png',
//   },
//   {
//     label: 'Slide 2',
//     imgPath: 'car-image-2.png',
//   },
//   {
//     label: 'Slide 3',
//     imgPath: 'image-1.png',
//   },
//   {
//     label: 'Slide 4',
//     imgPath: 'image-2.png',
//   },
//   {
//     label: 'Slide 5',
//     imgPath: 'car-image-2.png',
//   },
//   {
//     label: 'Slide 6',
//     imgPath: 'image-1.png',
//   },
// ];

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  async componentDidMount() {
    try {
      await this.props.loadSalesOrgData(this.props.enqueueSnackbar);
      await this.props.getShipToPartyData(this.props.enqueueSnackbar);
    } catch (err) {
      console.log(err);
    }
  }

  handleChangeIndex = index => {
    this.setState({
      index,
    });
  };

  handleNext = () => {
    this.setState(prevState => ({ index: prevState.index + 1 }));
  };

  handleBack = () => {
    this.setState(prevState => ({ index: prevState.index - 1 }));
  };

  render() {
    const { t, history } = this.props;
    // const { index } = this.state;

    return (
      <Container>
        <div style={styles.root}>
          {/* <AutoPlaySwipeableViews index={index} onChangeIndex={this.handleChangeIndex}>
            {MyCollection.map((item, idx) => (
              <div key={idx} style={{ ...styles.slide }}>
                <img
                  src={item.imgPath}
                  alt={item.label}
                  style={{ width: '600px', height: '400px' }}
                />
              </div>
            ))}
          </AutoPlaySwipeableViews> */}

          {/* <Stack direction="row" justifyContent="center" spacing={0.5}>
            {MyCollection.map((_, idx) => (
              <Paper
                key={idx}
                sx={{
                  borderRadius: '50%',
                  height: 8,
                  width: 8,
                  bgcolor: index === idx ? 'primary.main' : 'lightgray',
                  cursor: 'pointer',
                }}
                onClick={() => this.handleChangeIndex(idx)}
              />
            ))}
          </Stack> */}
        </div>

        <Stack spacing={1} sx={{ my: 12 }}>
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            sx={styles.menuStack}
          >
            {homeConfigData.map((d, i) => (
              <Paper
                elevation={3}
                onClick={() => d.onClick(history)}
                sx={styles.menuPaperView}
                key={i.toString()}
              >
                <Stack justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
                  <d.icon sx={styles.menuIcon} />
                  <Typography>{d.label(t)}</Typography>
                </Stack>
              </Paper>
            ))}
          </Stack>
        </Stack>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};
const cHome = connect(mapStateToProps, { loadSalesOrgData, getShipToPartyData })(Home);
const tHome = withTranslation(['homeScreenTranslations'])(cHome);
const sHome = withSnackbar(tHome);

export { sHome as Home };
